<template>
  <b-container fluid>
    <b-button variant="success" class="my-3" @click="createNews({ method:'create' })">Создать запись</b-button>
    <b-table :fields="fields"
             :items="categories"
             show-empty
             responsive
             id="mytable"
             no-sort-reset
             :tbody-tr-class="rowClass"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             :sort-direction="sortDirection"
             :sort-compare="sortCompare"
    >
      <template v-slot:cell(index)="row">
        <div>{{ (row.item.index + 1) }}</div>
      </template>
      <template v-slot:cell(client_type)="row">
        <div>{{ getClientNames(row.item.client_type) }}</div>
        <div>{{ getServerNames(row.item.server_types) }}</div>
      </template>
      <template v-slot:cell(actions)="row">
        <b-button size="sm" variant="warning" class="mr-1" @click="editNews({ method:'edit',item:row.item })">
          <i class="fas fa-pen"></i>
        </b-button>
        <b-button size="sm" variant="danger" class="mr-1" @click="deleteNews(row.item)">
          <i class="fas fa-trash-alt"></i>
        </b-button>
      </template>
      <template v-slot:cell(is_published)="row">
        <i v-if="row.value" class="fas fa-check"></i>
        <i v-else class="fas fa-times"></i>
        <span v-if="row.item.is_rotten" class="ml-2"><b-badge variant="secondary">Устаревшая</b-badge></span>
      </template>
      <template v-slot:cell(publication_date)="row">
        <p v-if="row.item.publication_date!==null">{{ new Date(row.value).toLocaleString('ru') }}</p>
        <p v-else>{{ row.item.publication_date }}</p>
      </template>
    </b-table>
    <b-row class="mx-0">
      <b-modal
        id="newsModal"
        ref="modal"
        title="Создание записи"
        size="lg"
        @ok="sendModalData($event)"
        @hidden="clearModal"
        ok-title="Отправить" ok-variant="success"
        cancel-variant="danger" cancel-title="Отменить"
        :no-close-on-backdrop=true
        :ok-disabled="veeErrors.any()"
      >
        <b-form ref="form" @submit.stop.prevent="sendModalData">
          <b-form-group id="title"
                        label="Заголовок *:"
                        label-for="title"
                        :invalid-feedback="getError('title')">
            <b-form-input
              id="title"
              name="title"
              v-model="form.title"
              required
              placeholder="Введите заголовок"
              data-vv-as="заголовок"
              v-validate="{ required: true }"
              :state="validateState('title')"
            ></b-form-input>
          </b-form-group>
          <b-row>
            <b-col md="2">
              <b-form-group label="Опубликовать:">
                <b-form-checkbox
                  id="published"
                  :disabled="form.type === 'Новости для телеграм канала'"
                  v-model="form.is_published"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-form-group id="category"
                            label="Тип *:"
                            label-for="category"
                            :invalid-feedback="getError('category')">
                <b-form-select
                  id="category"
                  name="category"
                  v-model="form.type"
                  :options="categoryTypes"
                  text-field="name"
                  value-field="name"
                  data-vv-as="Тип"
                  @change="selectedType($event)"
                  v-validate="{ required: true }"
                  :state="validateState('category')"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col v-if="form.type === 'Новости онлайн клиент Нова' || form.type === 'Новости толстый клиент Нова'" md="5">
              <b-form-group id="release"
                            label="Номер релиза *:"
                            label-for="release"
                            :invalid-feedback="getError('release')">
                <b-form-input
                  id="release"
                  name="release"
                  v-model="form.release_version"
                  required
                  placeholder="Введите номер релиза"
                  data-vv-as="номер релиза"
                  v-validate="{ required: true }"
                  @input="checkFormInputData('release_version')"
                  :state="validateState('release')"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="form.type === 'Новости толстый клиент Нова'">
            <b-col md="6">
              <b-form-group id="clientType"
                            label="Тип клиента:"
                            label-for="clientType"
                            :invalid-feedback="getError('clientType')">
                <b-form-select
                  id="clientType"
                  name="clientType"
                  v-model="form.client_type"
                  :options="clientTypes"
                  text-field="name"
                  value-field="id"
                  data-vv-as="Тип клиента"
                  v-validate="{ required: true }"
                  :state="validateState('clientType')"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group id="serverType"
                            label="Тип сервера:"
                            label-for="serverType"
                            :invalid-feedback="getError('serverType')">
                <b-form-select
                  id="serverType"
                  name="serverType"
                  multiple
                  v-model="form.server_types"
                  :options="serverTypes"
                  text-field="name"
                  value-field="id"
                  data-vv-as="Тип сервера"
                  v-validate="{ required: true }"
                  :state="validateState('serverType')"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group id="preview"
                        label="Краткое описание *:"
                        label-for="preview"
                        :invalid-feedback="getError('preview')">
            <b-form-input
              id="preview"
              name="preview"
              v-model="form.preview"
              data-vv-as="Краткое описание"
              v-validate="{required:true}"
              :state="validateState('preview')"
              placeholder="Введите превью новости:"
            ></b-form-input>
          </b-form-group>
          <b-form-group :invalid-feedback="getError('content')"
                        :state="validateState('content')"
          >
            <vue-editor v-model="form.content"
                        :show-preview="true"
                        name="content"
                        v-validate="{ required:true }"
                        :state="validateState('content')"
            />
            <b-form-textarea id="code-editor" :key="index" v-html="form.content"
                             @change="updateContent"></b-form-textarea>
          </b-form-group>
        </b-form>
      </b-modal>
    </b-row>
  </b-container>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'news',
  components: {
    VueEditor
  },
  data () {
    return {
      sendMethod: null,
      id: null,
      fields: [
        {
          key: 'index',
          label: '№',
          sortable: true
        },
        {
          key: 'title',
          label: 'Заголовок',
          sortable: false
        },
        {
          key: 'client_type',
          label: 'Тип клиента, сервер',
          sortable: false
        },
        {
          key: 'is_published',
          label: 'Опубликовано',
          sortable: false
        },
        {
          key: 'type',
          label: 'Тип',
          sortable: false
        },
        {
          key: 'publication_date',
          label: 'Дата публикации',
          sortable: false
        },
        {
          key: 'actions',
          label: 'Действия',
          sortable: false
        }
      ],
      form: {
        title: null,
        preview: null,
        content: null,
        is_published: false,
        type: null,
        server_types: [],
        client_type: null,
        create_date: null,
        publication_date: null,
        release_version: null
      },
      clientTypes: [
        { id: 1, name: 'Nova client' }
      ],
      selectedTypeName: null,
      showAlert: null,
      index: 0,
      sortBy: 'index',
      sortDesc: true,
      sortDirection: 'desc'
    }
  },
  watch: {
    'form.content' (to) {
      this.form.content = to
      this.index++
    }
  },
  computed: {
    ...mapState(
      {
        categories: state => state.news.categoriesList,
        categoryTypes: state => state.news.categoryTypes,
        serverTypes: state => state.news.serverTypes
      }
    )
  },
  mounted () {
    this.loadCategoryTypes().then(
      () => {
        this.getServerTypes().then(
          () => {
            this.categoriesList()
          },
          (error) => {
            console.log(error)
          }
        )
      },
      (error) => {
        console.log(error)
      }
    )
  },
  methods: {
    getClientNames (id) {
      switch (id) {
        case 1:
          return 'Nova client'
        default:
          break
      }
    },
    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.is_rotten) return 'table-danger'
    },
    getServerNames (servers) {
      let types = ''
      if (servers) {
        types = this.serverTypes
          .filter(obj => servers.includes(obj.id))
          .map(obj => obj.name)
          .join(', ')
      }
      return types
    },
    sortCompare (aRow, bRow, key) {
      const a = aRow[key]
      const b = bRow[key]
      if (key === 'id') {
        return a < b ? 1 : a > b ? -1 : 0
      }
    },
    updateContent (value) {
      this.form.content = value
    },
    selectedType (type) {
      this.selectedTypeName = type
      this.$validator.errors.clear()
    },
    createNews (news) {
      this.sendMethod = news.method
      this.$root.$emit('bv::show::modal', 'newsModal', event)
    },
    editNews (news) {
      this.sendMethod = news.method
      this.id = news.item.id
      this.form.title = news.item.title
      this.form.preview = news.item.preview
      this.form.content = news.item.content
      this.form.is_published = news.item.is_published
      this.form.type = news.item.type
      this.form.client_type = news.item.client_type
      this.form.server_types = news.item.server_types
      this.form.release_version = news.item.release_version
      this.$root.$emit('bv::show::modal', 'newsModal', event)
    },
    deleteNews (news) {
      this.deleteCategory({ id: news.id }).then(
        () => {
          this.categoriesList()
        },
        (error) => {
          console.log(error)
        }
      )
    },
    sendModalData (event) {
      event.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        this.sendLogic()
      })
    },
    sendLogic () {
      const myForm = JSON.parse(JSON.stringify(this.form))
      if (this.sendMethod === 'create') {
        this.createCategory(myForm).then(
          () => {
            this.$nextTick(() => {
              this.$refs.modal.hide()
            })
          },
          error => {
            console.log(error)
          }
        )
      } else if (this.sendMethod === 'edit') {
        this.editCategory({ id: this.id, form: myForm }).then(
          () => {
            this.$nextTick(() => {
              this.$refs.modal.hide()
            })
          },
          error => {
            console.log(error)
          }
        )
      }
    },
    clearModal () {
      for (const key in this.form) {
        this.form[key] = null
      }
      this.is_published = false
    },
    getError (ref) {
      return this.veeErrors.first(ref)
    },
    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    checkFormInputData (fieldName) {
      this.form[fieldName] = this.form[fieldName].replace(/,/g, '.')
    },
    ...mapActions('news', [
      'createCategory',
      'editCategory',
      'deleteCategory',
      'categoriesList',
      'loadCategoryTypes',
      'getServerTypes'
    ])
  }
}
</script>

<style scoped>
  .fa-check {
    color: #40b539;
  }

  .fa-times {
    color: #e7161a;
  }

  #code-editor {
    width: 100%;
    margin-top: 10px;
    min-height: 200px;
  }
</style>
